import { Modal, Button, Spin } from "antd";
import { useState } from "react";
import { LoadingOutlined } from "@ant-design/icons";
import "../../../styles/teamMember.scss";
import { useSelector } from "react-redux";
import {
  CREATING_INDUSTRY
} from "../../../store/contact-store/reducer";
import FormIndustry from "./formIndustry";

const ModalContacts = ({
  form,
  fetchSubData,
  isModalVisible,
  setIsModalVisible,
}) => {
  const [loading, setLoading] = useState(false);
  const { organisationId } = useSelector(({ auth }) => auth.user);

  const [industries, setIndustries] = useState({
    organisationId: organisationId,
    _id: "new",
    active: true,
  });

  const antIcon = (
    <LoadingOutlined style={{ fontSize: 18, color: "#fff" }} spin />
  );

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleOk = () => {
    setLoading(true);
    switch (isModalVisible.type) {
      case "Industry":
        CREATING_INDUSTRY(industries).then((data) => {
          fetchSubData();
          setTimeout(() => {
            form.setFields([
              {
                name: "industry",
                value: data?._id,
              },
            ]);
            setLoading(false);
            setIsModalVisible(false);
          }, 1000);
        });
        break;
      default:
        setLoading(false);
        break;
    }
  };

  const renderType = () => {
    switch (isModalVisible.type) {
      case "Industry":
        return <FormIndustry industries={industries} setIndustries={setIndustries} />;
      default:
        setLoading(false);
        break;
    }
  };

  return (
    <Modal
      title={"Add " + isModalVisible.type}
      visible={isModalVisible}
      onCancel={handleCancel}
      className="modal-sub"
      okText="Add"
      footer={[
        <Button key="cancel" onClick={handleCancel}>
          Cancel
        </Button>,
        <Button
          key="add"
          type="primary"
          onClick={handleOk}
          style={{ opacity: loading && 0.6 }}
        >
          {loading ? <Spin indicator={antIcon} /> : "Add"}
        </Button>,
      ]}
    >
      {renderType()}
    </Modal>
  );
};

export default ModalContacts;
